@if (invoice) {
  <div class="invoice-detail-container">
    <div class="invoice-header">
      <span class="status-badge" [class]="getStatusClass(invoice.status)">
        {{ invoice.status }}
      </span>
    </div>
    <div class="invoice-body">
      <!-- Collection status (gap A): the one sentence saying why this invoice
      is or is not being collected. See phase-2 doc, scenario-to-UI matrix. -->
      @if (showCollectionBlock) {
        <div class="collection-block">
          <span class="material-symbols-outlined collection-icon">info</span>
          <div class="collection-text">
            {{ collectionMessage }}
            @if (showGoToProfileLink) {
              <a class="collection-link" (click)="handleGoToPaymentProfile()">Open Payment Profile</a>
            }
          </div>
        </div>
      }
      <!-- Invoice Meta -->
      <div class="invoice-meta">
        <div class="meta-row">
          <span class="meta-label">Type</span>
          <span class="type-badge" [class]="getInvoiceTypeClass(invoice.type)">
            {{ getInvoiceTypeDisplay(invoice.type) }}
          </span>
        </div>
        <div class="meta-row">
          <span class="meta-label">Created</span>
          <span class="meta-value">{{ formatDate(invoice.createdAt) }}</span>
        </div>
        @if (invoice.dueDate) {
          <div class="meta-row">
            <span class="meta-label">Due Date</span>
            <span class="meta-value">{{ formatDate(invoice.dueDate) }}</span>
          </div>
        }
        @if (invoice.paidAt) {
          <div class="meta-row">
            <span class="meta-label">Paid On</span>
            <span class="meta-value">{{ formatDate(invoice.paidAt) }}</span>
          </div>
        }
      </div>
      <!-- Line Items -->
      <div class="section">
        <div class="section-title">Line Items</div>
        <div class="line-items">
          @for (item of invoice.lineItems; track item.id) {
            <div class="line-item">
              <span class="line-desc">{{ item.description }}</span>
              <span class="line-amount">{{ formatCurrency(item.amount) }}</span>
            </div>
          }
        </div>
      </div>
      <!-- Summary -->
      <div class="invoice-summary">
        <div class="summary-row">
          <span>Subtotal</span>
          <span>{{ formatCurrency(invoice.subtotal) }}</span>
        </div>
        @if (invoice.discountAmount) {
          <div class="summary-row discount">
            <span>Discount</span>
            <span>-{{ formatCurrency(invoice.discountAmount) }}</span>
          </div>
        }
        <div class="summary-row">
          <span>Tax</span>
          <span>{{ formatCurrency(invoice.taxAmount) }}</span>
        </div>
        <div class="summary-row total">
          <span>Total</span>
          <span>{{ formatCurrency(invoice.total) }}</span>
        </div>
        @if (invoice.amountDue > 0) {
          <div class="summary-row due">
            <span>Amount Due</span>
            <span>{{ formatCurrency(invoice.amountDue) }}</span>
          </div>
        }
      </div>
      <!-- Payments -->
      @if (invoice.payments.length) {
        <div class="section">
          <div class="section-title">Payments</div>
          <div class="payments-list">
            @for (payment of invoice.payments; track payment.id) {
              <div class="payment-row">
                <span class="payment-method">{{ getPaymentMethodDisplay(payment.method) }}</span>
                <span class="payment-amount">{{ formatCurrency(payment.amount) }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="invoice-footer">
      <!-- PDF and Send removed: moneta has no invoice-PDF or invoice-email endpoint, and
      both buttons only raised a success toast while doing nothing. Restore them with
      the endpoints, not before. -->
      @if (invoice.status === 'OPEN' || invoice.status === 'PARTIALLY_PAID') {
        <app-button size="small" type="primary" (onClick)="handleChargeCard()">
          Charge Card
        </app-button>
        <app-button size="small" type="secondary" (onClick)="handleRecordPayment()">
          Record Payment
        </app-button>
      }
      @if (invoice.status === 'OPEN') {
        <app-button size="small" type="warning" (onClick)="handleVoid()">
          Void
        </app-button>
      }
      @if (canCreditNote) {
        <app-button size="small" type="secondary" (onClick)="handleCreditNote()">
          Credit note
        </app-button>
      }
      @if (canMarkUncollectible) {
        <app-button size="small" type="warning" (onClick)="handleMarkUncollectible()">
          Mark uncollectible
        </app-button>
      }
    </div>
  </div>
}